export default "__VITE_ASSET__vyOcKfdH__"